import { nanoid } from 'nanoid';
import { overlay } from 'overlay-kit';

type Dialog<T> = (props: T) => JSX.Element;

type Options<T> = Omit<T, 'isOpen' | 'onClose'> & {
  overlayId?: string;
};

export const createDialogManager = <T>(Dialog: Dialog<T>) => {
  return {
    open({ overlayId = nanoid(8), ...options }: Options<T>) {
      return overlay.open(
        ({ unmount }) => Dialog({ ...(options as T), onClose: unmount }),
        { overlayId },
      );
    },

    async openAsync({
      overlayId = nanoid(8),
      ...options
    }: Options<T>): Promise<boolean> {
      const confirm = (await overlay.openAsync(
        ({ close }) => Dialog({ ...(options as T), onClose: close }),
        { overlayId },
      )) as boolean;
      overlay.unmount(overlayId);
      return confirm;
    },

    close(overlayId: string) {
      overlay.close(overlayId);
    },

    unmount(overlayId: string) {
      overlay.unmount(overlayId);
    },
  };
};
